import { Button, colors, Container } from "@mui/material";
import React, { useEffect } from "react";
import ProductListInput from "../../../Components/CustomProductInput/ProductListInput";
import { Grid } from "@mui/material";
import CustomInput from "../../../Components/CustomInput/CustomInput";
import WareHouseRes from "../../../Components/CustomWarehouse/Rec/WareHouseRes";
import CustomSnackbar from "../../../Components/Snackbar/Snackbar";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";

export default function ProductAssembly(props) {
  const [state, setState] = React.useState({
    JProductName: "",
    JProductCode: "",
    JQuantity: "",
    LaborCostUnit: "", // ค่าแรง/หน่วย
    ExpensesUnit: "", // โสหุ้ย/หน่วย
    JWarehouse: "",
    JLocation: "",
    JUnitCode: "",
    opensnackbar: false,
    icon: null,
    color: InfoRoundedIcon,
    autoClose: 3600,
    messageAlert: "",
    cleanData: false,
  });

  return (
    <Container>
      <Grid container spacing={2} sx={{ m: 1 }}>
        <Grid lg={12}>
          <ProductListInput
            id={"productInputProductAssembly"}
            label={"รหัสสินค้า"}
            keyDown={(_) => {}}
            resultData={(e) => resultProductListInput(e)}
            inputDetailDisable={false}
            defaultValue={state.JProductCode}
            defaultValueName={state.JProductName}
          />
        </Grid>
        <Grid lg={4}>
          <CustomInput
            resData={(e) =>
              setState((prevState) => ({
                ...prevState,
                JQuantity: e,
              }))
            }
            label={"ปริมาณ"}
            inputType={"number"}
            id={"JQuantity"}
            defaultValue={state.JQuantity}
            keyDown={(e) => {
              console.log(e);
            }}
          />
        </Grid>
        <Grid lg={4}>
          <CustomInput
            resData={(e) =>
              setState((prevState) => ({
                ...prevState,
                LaborCostUnit: e,
              }))
            }
            label={"ค่าแรง/หน่วย"}
            inputType={"number"}
            id={"JDLAmount"}
            defaultValue={state.LaborCostUnit}
            keyDown={(e) => {
              console.log(e);
            }}
          />
        </Grid>
        <Grid lg={4}>
          <CustomInput
            resData={(e) =>
              setState((prevState) => ({
                ...prevState,
                ExpensesUnit: e,
              }))
            }
            defaultValue={state.ExpensesUnit}
            label={"โสหุ้ย/หน่วย"}
            inputType={"number"}
            id={"ExpensesUnit"}
            keyDown={(e) => {
              console.log(e);
            }}
          />
        </Grid>
        {/* {
                    "JWarehouse": "1001",
                "JLocation": "1001001",
                "JUnitCode": "02"
} */}
        <Grid lg={12}>
          <WareHouseRes
            productCode={state.JProductCode}
            resultData={(e) =>
              setState((prevState) => ({
                ...prevState,
                JWarehouse: e.warehouseRec,
                JLocation: e.location,
                JUnitCode: e.unit,
              }))
            }
            defaultValue={[
              {
                warehouse: state.JWarehouse,
                location: state.JLocation,
                unitCode: state.JUnitCode,
              },
            ]}
          />
        </Grid>
        <Grid lg={12}>
          <Button
            variant="outlined"
            onClick={() => {
              Submit();
            }}
          >
            ตกลง
          </Button>
          <Button variant="outlined" onClick={() => props.CloseDialog()}>
            ปิด
          </Button>
        </Grid>
      </Grid>
      <CustomSnackbar
        place="br"
        color={state.color}
        icon={state.icon}
        autoClose={state.autoClose}
        message={state.messageAlert}
        open={state.opensnackbar}
        closeNotification={() => {
          setState((prevState) => ({
            ...prevState,
            opensnackbar: false,
          }));
        }}
        close
      />
    </Container>
  );
}
